import { render, staticRenderFns } from "./AltSsBrandTokens.vue?vue&type=template&id=4f5e1020&"
import script from "./AltSsBrandTokens.vue?vue&type=script&lang=js&"
export * from "./AltSsBrandTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports